import type { Iso3166Alpha3Lower, LocaleCode } from "../types";

import { findLocaleCodeFromIso3166Alpha3Lower } from "../registry/find-locale-code-from-iso3166-alpha3-lowercase";
import { LOCALE_DEFINITIONS } from "../registry/locale-registry-data";

const REGION_HOME_CARE_PATH_PATTERN = /^\/home-care\/([a-z]{3})(?:\/|$)/;

function resolveLocaleCodeFromPathPrefix(pathname: string): LocaleCode | null {
  const match = REGION_HOME_CARE_PATH_PATTERN.exec(pathname.toLowerCase());

  if (!match) {
    return null;
  }

  return findLocaleCodeFromIso3166Alpha3Lower(
    match[1] as Iso3166Alpha3Lower,
    LOCALE_DEFINITIONS,
  );
}

export { resolveLocaleCodeFromPathPrefix };
